import {useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActionsFree";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import TableRoutes from "./TableRoutes";

import axiApi from "ApiCaller";
import UnloadRouteFlyModel from "site-apps/distribution/route/UnloadRouteFlyModel";

const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
const AlertQuestion = new SwalAlertChoice({
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
});
const ViewRoutes = ({keyTab, setKeyTab}) => {
    // -
    // const navigate = useNavigate();
    const {t: _Tt} = useTranslation("tables");
    const {t: _Td} = useTranslation("datestimes");
    const navigate = useNavigate();
    const [buttonsTB, setButtonsTB] = useState(new ButtonsActions());
    const [itemsShown, setItemsShown] = useState([]);
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({...UnloadRouteFlyModel});
    const [showForm, setShowForm] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const params = useRef({drivers: [], zones: []});
    const orderingRef = useRef(new OrderingModel());
    const headersTable = useMemo(
        () => [
            {
                name: _Td("labels.created_at"),
                attr: 0,
                direction: "desc",
                active: true,
                default: true,
                style: {width: "100px"},
                value: -1,
            },
            {name: _Tt("common.name"), attr: 1, direction: "asc", active: false},
            {name: _Tt("common.description"), attr: 2, direction: "asc", active: false},
            {name: _Tt("users.driver"), attr: 3, direction: "asc", active: false},
            {name: _Tt("routes.zone"), attr: 4, direction: "asc", active: false},
            {name: _Tt("common.status"), attr: 5, direction: "asc", active: false},
            {name: _Td("labels.started_at"), attr: 6, direction: "asc", active: false, style: {width: "100px"}},
            {name: _Td("labels.opened_at"), attr: 7, direction: "asc", active: false, style: {width: "100px"}},
            {name: _Td("labels.completed_at"), attr: 8, direction: "asc", active: false, style: {width: "100px"}},
        ],
        [_Tt],
    );

    useEffect(() => {
        onMounted(keyTab);
    }, [keyTab]);

    const initialized = useRef(false);

    const onMounted = (keyTab_) => {
        if (keyTab_ !== "instances") return;
        if (initialized.current) {
            applyFilters();
            return;
        }
        initialized.current = true;
        // --- INITIALIZING ---

        const buttons = {...buttonsTB};
        // -
        buttons.title = "Plantillas bolseo";
        // buttons.add.active = true;
        // buttons.add.onClick = onClickAdd;
        // buttons.add.disabled = false;
        // -
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        // -
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB({...buttons});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            applyFilters();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {...UnloadRouteFlyModel};
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => applyFilters();

        filters.current.filter = () => {
            applyFilters();
        };
        fetchGetData();
    };

    const fetchGetData = async () => {
        setIsLoading(true);
        const resp = await axiApi.get("/api/distribution/routes/fly-tippings/instances/");
        if (resp.data) {
            if (resp.data.items.length) {
                items.current.all = [...resp.data.items];
                items.current.shown = [...resp.data.items];
                setItemsShown([...resp.data.items]);
            }
            if (resp.data.params) {
                params.current = {...resp.data.params};
            }
        }
        setIsLoading(false);
    };

    const onClickAdd = () => {
        setItem({...UnloadRouteFlyModel});
        setShowForm(true);
    };

    const onClickEdit = () => {
        if (items.current.chosen.length > 1 || items.current.chosen.length === 0) {
            return false;
        }
        const id = parseInt(items.current.chosen[0]);
        navigate(`/route-management/route/${id}/`);
    };
    const onClickDelete = () => {
        AlertQuestion.warning(
            "Se eliminarán las rutas seleccionadas",
            `Se borrarán los ${items.current.chosen.length} seleccionados. Los bolseos (mooch) quedarán libres para futuras rutas.`,
        ).then((resp) => {
            if (resp.isConfirmed) {
                let ids = items.current.getChosenIds();
                setIsLoading(true);
                axiApi
                    .delete("/api/distribution/routes/fly-tippings/instances/delete/", {data: {ids}})
                    .then((resp) => {
                        if (resp.data.status) {
                            Alert.success("Eliminadas", "Rutas eliminadas correctamente");
                        }
                    })
                    .catch((error) => {
                        const msg = error.response?.data?.message || "Error al eliminar las rutas";
                        Alert.error("Error", msg);
                    })
                    .finally(() => {
                        items.current.clearChosen();
                        const buttons = {...buttonsTB};
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        setButtonsTB(buttons);
                        setIsLoading(false);
                        applyFilters();
                    });
            }
        });
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/routes/fly-tippings/instances/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                setItemsShown([...resp.data.items]);
                items.current.setShowed(resp.data.items);
                if (resp.data && resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <TopBarActions actions={buttonsTB} filtersRef={filters} className="sticky-top" style={{top: "72px"}} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />
            <div className="col-12">
                <LoaderSpinner isLoading={isLoading}>
                    <TableRoutes
                        items={items}
                        itemsShown={itemsShown}
                        setItemsShown={setItemsShown}
                        buttonsTB={buttonsTB}
                        setButtonsTB={setButtonsTB}
                        orderingRef={orderingRef}
                    />
                </LoaderSpinner>
            </div>
        </>
    );
};
export default ViewRoutes;
